import axios from 'axios'
import utilits from '@/assets/utilits/request.js'
export default {
  namespaced: true,
  state: {
    allRights: []
  },
  mutations: {
    updateAllRights (state, obj) {
      state.allRights = obj
    }
  },
  getters: {},
  actions: {
    getGroupList ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getcompanygroupname',
        obj,
        callback
      )
    },
    getcogroupinfo ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getcogroupinfo',
        obj,
        callback
      )
    },
    delGroup ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/delgroup', obj, callback)
    },
    addGroup ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/addcogroup', obj, callback)
    },
    modifyGroupName ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/modifygroupname',
        obj,
        callback
      )
    },
    getAllrights ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getuserallrights',
        obj,
        callback
      )
    },

    getgroupright ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getgroupright',
        obj,
        callback
      )
    },
    addUsersToGroup ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/updategroupinfo', obj, callback)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/permissions.js